module.exports = __webpack_public_path__ + "img/scan.f64cffa5.svg";